import { types } from 'mobx-state-tree'
import { UserRole } from './response-models'
import { StatisticalHistory } from './StatisticalHistory'

export const UserOverviewStats = types.model('UserOverviewStats').props({
  user_id: types.number,
  display_name: types.string,
  profile_image_url: types.maybeNull(types.string),
  exclude_from_leaderboard: types.boolean,
  last_activity: types.maybeNull(types.string),
  starting_knowledge: types.maybeNull(types.number),
  current_knowledge: types.maybeNull(types.number),
  knowledge_gain: types.maybeNull(types.number),
  stats_history: types.array(StatisticalHistory),
  deactivation_datetime: types.maybeNull(types.string),
  roles: types.frozen(),
})
